import React from 'react'

export const v = (name) => `var(--${name})`

// The sun's road on the water: jittered widths, centres and gaps so it
// scatters like light instead of stacking like a ladder.
const ROAD = [
  [432, 307, 20, 2.4, 1, '3.2s', '-0.4s'],
  [420, 314.5, 32, 2.6, 0.95, '4.1s', '-1.7s'],
  [434, 323, 24, 2.4, 0.9, '3.6s', '-0.9s'],
  [416, 331.5, 44, 2.8, 0.88, '4.6s', '-2.3s'],
  [417, 341, 30, 2.6, 0.82, '3.9s', '-1.1s'],
  [417, 350, 54, 3, 0.8, '4.9s', '-3.1s'],
  [415, 359.5, 38, 2.8, 0.72, '3.4s', '-0.6s'],
  [409, 369, 66, 3.2, 0.7, '5.2s', '-2.6s'],
  [407, 379.5, 46, 2.8, 0.62, '4.3s', '-1.4s'],
  [401, 390, 78, 3.4, 0.6, '3.7s', '-2.9s'],
  [420, 401, 56, 3, 0.52, '5.5s', '-0.2s'],
  [392, 411.5, 88, 3.6, 0.5, '4.4s', '-3.4s'],
  [412, 421, 64, 3.2, 0.42, '3.8s', '-1.9s'],
]

export const SunRoad = () => (
  <g className="sunlit sun-road" style={{ fill: v('rfl') }}>
    {ROAD.map(([x, y, w, h, o, dur, delay]) => (
      <rect
        key={y}
        className="rfl"
        x={x} y={y} width={w} height={h} rx={h / 2}
        fillOpacity={o}
        style={{ animationDuration: dur, animationDelay: delay }}
      />
    ))}
  </g>
)

export const Water = () => (
  <>
    <rect x="0" y="300" width="800" height="200" fill="url(#sky-sea)" />
    <g className="sunlit">
      <rect x="0" y="299" width="800" height="1.6" style={{ fill: v('horizon') }} opacity="0.55" />
    </g>
    {/* Cools the warm band the gradients bake in at the waterline as the sun
        climbs. Above sky and sea, below anything that floats. */}
    <rect className="shade" x="0" y="200" width="800" height="220" fill="url(#sky-damp)" />
  </>
)

export const Swells = () => (
  <g fill="none" style={{ stroke: v('wave') }} strokeLinecap="round">
    <path className="wave" style={{ animationDuration: '17s' }} d="M60,340 q34,-5 68,0 t68,0" strokeWidth="2" opacity="0.3" />
    <path className="wave" style={{ animationDuration: '13s', animationDelay: '-4s' }} d="M600,356 q38,-5 76,0 t76,0" strokeWidth="2" opacity="0.26" />
    <path className="wave" style={{ animationDuration: '20s', animationDelay: '-7s' }} d="M120,392 q44,-6 88,0 t88,0" strokeWidth="2.4" opacity="0.24" />
    <path className="wave" style={{ animationDuration: '15s', animationDelay: '-2s' }} d="M580,404 q44,-6 88,0 t88,0" strokeWidth="2.4" opacity="0.22" />
  </g>
)
